<template>
  <div>
    <div class="gallery" v-if="!loadStatus">
      <div class="gallery-image" v-for="i in 5" :key="i">
        <div class="portrait-loader">
          <Skeleton height="80%" width="100%" />
        </div>
        <div class="portrait-info">
          <Skeleton width="100%" />
        </div>
      </div>
    </div>
    <template v-if="loadStatus && bundlesList.length">
      <div class="caption-holder">
        <h5>Gift Sets</h5>
      </div>

      <div class="gallery">
        <div
          class="gallery-image relative"
          v-for="bundle in bundlesList"
          :key="bundle.id"
        >
          <div class="hidden absolute top-3 left-3">
            <label class="checkbox-container">
              <input
                type="checkbox"
                @click="handleProductSelect(bundle)"
                :checked="isInShoppingbag(bundle)"
              />
              <span class="checkmark checkmark-center"></span>
            </label>
          </div>
          <router-link
            :to="{ name: 'BundleDetail', params: { id: bundle.id } }"
            class="gift-link"
          >
            <div
              class="portrait"
              :class="[isInShoppingbag(bundle) && 'active']"
            >
              <img :src="photoURL(bundle)" @error="handleBrokenImage($event)" />
            </div>

            <div class="portrait-info">
              <div>
                <p>{{ bundle.attributes.name }}</p>
                <span v-show="showPrices">{{
                  bundle.attributes.lowestPrice
                    ? formatCurrency(bundle.attributes.lowestPrice)
                    : formatCurrency(0)
                }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Util from '../../mixins/Util'
import {
  progressStatus,
  defaultNotFoundImage,
  handleBrokenImage,
  isCard
} from '../../helpers'

export default {
  name: 'BundlesGallery',
  mixins: [Util],

  components: {
    Skeleton: () => import('@/components/Universal/Skeleton')
  },

  data: () => ({
    handleBrokenImage: handleBrokenImage
  }),

  computed: {
    loadStatus() {
      return progressStatus(this.loadBundles)
    },
    ...mapState({
      loadBundles: state => state.product.loadBundles,
      bundlesList: state => state.product.bundlesList,
      shoppingBagProducts: state => state.order.shoppingBagProducts
    }),
    showPrices() {
      return this.$store.getters['team/showPrices']
    }
  },

  created() {
    this.$store.dispatch('product/getProductBundles')
  },

  methods: {
    photoURL(product) {
      if (product.attributes.images.length) {
        return product.attributes.images[0].url
      }
      return defaultNotFoundImage
    },
    isInShoppingbag(bundle) {
      return this.shoppingBagProducts.find(
        shoppingProduct => shoppingProduct.bundle_id === bundle.id
      )
    },
    handleProductSelect(product) {
      if (this.isInShoppingbag(product)) {
        const bundle = this.shoppingBagProducts.find(
          shoppingProduct => shoppingProduct.bundle_id === product.id
        )
        if (bundle) {
          this.removeItem(bundle)
        }
      } else {
        this.$router.push({ name: 'BundleDetail', params: { id: product.id } })
      }
    },
    removeItem(product) {
      if (product.attributes && isCard(product.attributes.tagList)) {
        localStorage.removeItem('selectedCard')
      }
      this.$store.dispatch('order/removeShoppingBagItem', product)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.gallery {
  display: flex;
  flex-wrap: wrap;
  grid-column-gap: 1.85rem;
  padding-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.gallery-image {
  flex-basis: 31%;
  margin-bottom: 1.25rem;

  a {
    text-decoration: none;
  }

  a:hover {
    opacity: 1;
    color: $onyx;
    text-decoration: none;
  }
  .portrait-loader {
    width: 100%;
    border: 1px solid #a09c95;
    padding: 2rem;
    height: 300px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .portrait {
    width: 100%;
    height: 300px;
    border: 1px solid $gray-variant-2;
    transition: border 0.3s linear;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border 0.3s linear;

    img {
      padding: 2rem;
      width: 80%;
      height: 240px;
      max-width: 200px;
      cursor: pointer;
      object-fit: contain;
      display: block;
      margin: 0 auto;
    }
    &.active {
      border: 1.5px solid $main-6;
    }

    &:hover {
      border: 1.5px solid $main-6;
    }
  }

  .portrait-info {
    width: 100%;
    padding: 1rem 0;
    color: $main-6;

    & > div {
      display: flex;

      p {
        display: inline-block;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 180px;
        text-align: left;
        font-size: 0.875rem;
        font-family: $inter;
        opacity: 0.8;
      }

      span {
        margin-left: auto;
        font-size: 0.875rem;
        font-family: $inter;
        opacity: 0.8;
      }
    }
  }
}

@media screen and (max-width: 950px) and (min-width: 601px) {
  .gallery {
    padding-top: 2rem;
    margin-bottom: 2rem;
  }

  .gallery-image {
    flex-basis: 50%;
  }
}

@media screen and (max-width: 600px) and (min-width: 350px) {
  .gallery {
    flex-direction: column;
  }
}
</style>
